<template>
  <div class="mb-5">
    <ValidationObserver ref="observer">
      <v-row>
        <v-col cols="12" sm="6" md="3">
          <datepicker-cadu
            validateProviderRules="required"
            :menuOpen="menuOpen"
            :inputTitle="inputTitle"
            :inputValue="competencia"
            :propDate="competencia"
            :propMonths="allowedMonths"
            @selected="(data) => selecionarData(data)"
            @value="(value) => selecionarData(value)"
            :disabled="isMonthEmpty || !edit"
            ref="date"
          ></datepicker-cadu>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <input-cadu
            title="Última Atualização"
            v-model="ultimaAtualizacao"
            icon="calendar"
            v-mask="'##/##/####'"
            :colorText="$vuetify.theme.themes.light.fontColor1"
            disabled
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="pr-0">
          <GridColaborador
            @totalCola="(value) => (totalColaboradorA = value)"
            @totalPcd="(value) => (totalPcdA = value)"
            @totalGeral="(value) => (totalGeralA = value)"
            :disabled="editProp"
            texto="COLABORADORES DA UNIMED"
            ref="grid"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="pr-0">
          <GridColaborador
            @totalCola="(value) => (totalColaboradorB = value)"
            @totalPcd="(value) => (totalPcdB = value)"
            @totalGeral="(value) => (totalGeralB = value)"
            texto="COLABORADORES DOS SERVIÇOS PRÓPRIOS"
            :disabled="editProp"
            ref="gridProprio"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="pr-0">
          <div>
            <v-row align="center">
              <v-col class="pa-2 pr-0" cols="12" sm="3" md="3" lg="3">
                <div class="primary1--text title">
                  TOTAL UNIMED
                </div>
              </v-col>
              <v-col class="pa-2" cols="12" sm="3" md="3" lg="3">
                <input-cadu
                  textAlign="end"
                  colorBgField="#333"
                  colorInput="white"
                  :mask="[
                    '####',
                    '#.###',
                    '##.###',
                    '###.###',
                    '####.###',
                    '#.###.###',
                    '##.###.###',
                    '###.###.###',
                    '#.###.###.##'
                  ]"
                  disabled
                  :value="totalColaborador"
                />
              </v-col>
              <v-col :class="$vuetify.breakpoint.xs ? 'pa-2 ml-0' : 'pa-2'" cols="12" sm="3" md="3" lg="3">
                <input-cadu
                  textAlign="end"
                  colorBgField="#333"
                  colorInput="white"
                  :mask="[
                    '####',
                    '#.###',
                    '##.###',
                    '###.###',
                    '####.###',
                    '#.###.###',
                    '##.###.###',
                    '###.###.###',
                    '#.###.###.##'
                  ]"
                  disabled
                  :value="totalPcd"
                />
              </v-col>
              <v-col :class="$vuetify.breakpoint.xs ? 'pa-2' : 'pa-2'" cols="12" sm="3" md="3" lg="3">
                <input-cadu
                  textAlign="end"
                  colorBgField="#333"
                  colorInput="white"
                  :mask="[
                    '####',
                    '#.###',
                    '##.###',
                    '###.###',
                    '####.###',
                    '#.###.###',
                    '##.###.###',
                    '###.###.###',
                    '#.###.###.##'
                  ]"
                  disabled
                  :value="totalGeral"
                />
              </v-col>
            </v-row>
          </div>
        </v-col>
      </v-row>
    </ValidationObserver>
    <modal-cancelar v-model="showModalCancelar" @cancelar-edicao="cancelarEdicao()" />
  </div>
</template>

<script>
import { ValidationObserver } from 'vee-validate'
import { mask } from 'vue-the-mask'
import { EventBus } from '../../../../../services/EventBus/EventBus'
import GridColaborador from './Shared/GridColaborador'
import Colaborador from '@/services/Perfil/Colaborador'
import { cloneDeep, isEqual } from 'lodash'

export default {
  directives: {
    mask
  },
  props: {
    editProp: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  components: {
    ValidationObserver,
    GridColaborador
  },
  data() {
    return {
      competencia: '',
      competenciaClone: '',
      ultimaAtualizacao: '',
      totalColaboradorA: 0,
      totalPcdA: 0,
      totalGeralA: 0,
      totalColaboradorB: 0,
      totalPcdB: 0,
      totalGeralB: 0,
      // DatePicker
      menuOpen: false,
      inputTitle: 'Competência',
      allowedMonths: [],
      loading: false,
      tokenBearer: '',
      id: '',
      colaboradores: {},
      colaboradoresProprios: {},
      edit: JSON.parse(localStorage.getItem('optionEdit')),
      cloneColaborador: {},
      editavel: false,
      showModalCancelar: false
    }
  },
  async beforeMount() {
    this.tokenBearer = localStorage.getItem('tokenBearer')
    await this.getColaborador()

    EventBus.$on('carregarTableColaborador', (carregar) => {
      if (carregar) {
        this.getColaboradores()
        this.getPendencias()
        EventBus.$emit('carregarTableColaborador', false)
      }
    })
  },
  methods: {
    async cancelarEdicao() {
      this.showModalCancelar = false
      await this.getColaborador()
    },
    validarMudanca() {
      let data = this.$refs.grid.returnValues()
      let dataProprio = this.$refs.gridProprio.returnValues()

      let newObj = {
        id: this.id,
        competencia: this.competencia,
        dataAtualizacao: this.ultimaAtualizacao,
        usuarioAtualizacao: {
          id: 5506,
          nome: 'Usuário Teste',
          unimed: {
            id: 2,
            codigo: 999,
            nomeFantasia: 'UNIMED BRASIL 2',
            textoExibicao: null
          }
        },
        editavel: this.editavel,
        itens: [
          {
            id: 135,
            servicoProprio: false,
            tipoItem: 'DIRETOR',
            pcd: false,
            quantidadeItens: data.diretor * 1 || 0
          },
          {
            id: 145,
            servicoProprio: false,
            tipoItem: 'DIRETOR',
            pcd: true,
            quantidadeItens: data.pcdDiretor * 1 || 0
          },
          {
            id: 134,
            servicoProprio: false,
            tipoItem: 'GESTOR',
            pcd: false,
            quantidadeItens: data.gestor * 1 || 0
          },
          {
            id: 132,
            servicoProprio: false,
            tipoItem: 'GESTOR',
            pcd: true,
            quantidadeItens: data.pcdGestor * 1 || 0
          },
          {
            id: 133,
            servicoProprio: false,
            tipoItem: 'COLABORADOR',
            pcd: false,
            quantidadeItens: data.colaborador * 1 || 0
          },
          {
            id: 142,
            servicoProprio: false,
            tipoItem: 'COLABORADOR',
            pcd: true,
            quantidadeItens: data.pcdColaborador * 1 || 0
          },
          {
            id: 122,
            servicoProprio: false,
            tipoItem: 'ESTAGIARIO',
            pcd: false,
            quantidadeItens: data.estagiario * 1 || 0
          },
          {
            id: 127,
            servicoProprio: false,
            tipoItem: 'ESTAGIARIO',
            pcd: true,
            quantidadeItens: data.pcdEstagiario * 1 || 0
          },
          {
            id: 137,
            servicoProprio: false,
            tipoItem: 'JOVEM_APRENDIZ',
            pcd: false,
            quantidadeItens: data.aprendiz * 1 || 0
          },
          {
            id: 124,
            servicoProprio: false,
            tipoItem: 'JOVEM_APRENDIZ',
            pcd: true,
            quantidadeItens: data.pcdAprendiz * 1 || 0
          },
          {
            id: 129,
            servicoProprio: false,
            tipoItem: 'TEMPORARIO',
            pcd: false,
            quantidadeItens: data.temporario * 1 || 0
          },
          {
            id: 136,
            servicoProprio: false,
            tipoItem: 'TEMPORARIO',
            pcd: true,
            quantidadeItens: data.pcdTemporario * 1 || 0
          },
          {
            id: 138,
            servicoProprio: true,
            tipoItem: 'DIRETOR',
            pcd: false,
            quantidadeItens: dataProprio.diretor * 1 || 0
          },
          {
            id: 140,
            servicoProprio: true,
            tipoItem: 'DIRETOR',
            pcd: true,
            quantidadeItens: dataProprio.pcdDiretor * 1 || 0
          },
          {
            id: 130,
            servicoProprio: true,
            tipoItem: 'GESTOR',
            pcd: false,
            quantidadeItens: dataProprio.gestor * 1 || 0
          },
          {
            id: 131,
            servicoProprio: true,
            tipoItem: 'GESTOR',
            pcd: true,
            quantidadeItens: dataProprio.pcdGestor * 1 || 0
          },
          {
            id: 143,
            servicoProprio: true,
            tipoItem: 'COLABORADOR',
            pcd: false,
            quantidadeItens: dataProprio.colaborador * 1 || 0
          },
          {
            id: 144,
            servicoProprio: true,
            tipoItem: 'COLABORADOR',
            pcd: true,
            quantidadeItens: dataProprio.pcdColaborador * 1 || 0
          },
          {
            id: 123,
            servicoProprio: true,
            tipoItem: 'ESTAGIARIO',
            pcd: false,
            quantidadeItens: dataProprio.estagiario * 1 || 0
          },
          {
            id: 125,
            servicoProprio: true,
            tipoItem: 'ESTAGIARIO',
            pcd: true,
            quantidadeItens: dataProprio.pcdEstagiario * 1 || 0
          },
          {
            id: 126,
            servicoProprio: true,
            tipoItem: 'JOVEM_APRENDIZ',
            pcd: false,
            quantidadeItens: dataProprio.aprendiz * 1 || 0
          },
          {
            id: 128,
            servicoProprio: true,
            tipoItem: 'JOVEM_APRENDIZ',
            pcd: true,
            quantidadeItens: dataProprio.pcdAprendiz * 1 || 0
          },
          {
            id: 139,
            servicoProprio: true,
            tipoItem: 'TEMPORARIO',
            pcd: false,
            quantidadeItens: dataProprio.temporario * 1 || 0
          },
          {
            id: 141,
            servicoProprio: true,
            tipoItem: 'TEMPORARIO',
            pcd: true,
            quantidadeItens: dataProprio.pcdTemporario * 1 || 0
          }
        ]
      }

      newObj.usuarioAtualizacao = this.cloneColaborador.usuarioAtualizacao

      if (!isEqual(this.cloneColaborador, newObj)) {
        this.showModalCancelar = true
      }
    },
    async getColaborador() {
      this.getColaboradores()
      this.getPendencias()
    },
    async getPendencias() {
      this.loading = true

      const colaborador = new Colaborador(this.tokenBearer, this.$appConfig.config.API, this.$idUnimed)

      await colaborador
        .getPendentesColaboradores()
        .then((res) => (this.allowedMonths = res.data))
        .catch((err) => {
          this.$emit('error', err)
          console.error(err)
        })
        .finally(() => (this.loading = false))
    },
    async getColaboradores() {
      this.loading = true

      const colaborador = new Colaborador(this.tokenBearer, this.$appConfig.config.API, this.$idUnimed)

      await colaborador
        .getUltimoColaborador()
        .then((res) => {
          const data = res.data

          if (data) {
            const itens = data.itens

            this.cloneColaborador = cloneDeep(data)
            this.competencia = data.competencia
            this.competenciaClone = data.competencia
            this.ultimaAtualizacao = data.dataAtualizacao
            this.id = data.id
            this.editavel = data.editavel

            this.$refs.grid.modelValues(itens.filter((el) => !el.servicoProprio))
            this.$refs.gridProprio.modelValues(itens.filter((el) => el.servicoProprio))
            this.$emit('editavel', data.editavel)
          } else {
            this.$emit('editavel', true)
          }
        })
        .finally(() => (this.loading = false))
    },
    competenciaEquals(mesFormatado, mesSemFormatacao) {
      let arrMes = mesSemFormatacao.split('-')
      let mesComFormatacao = `${arrMes[1]}/${arrMes[0]}`
      return mesFormatado === mesComFormatacao
    },
    async putColaborador(justificativa) {
      let result = this.allowedMonths[0] ? this.competenciaEquals(this.competencia, this.allowedMonths[0]) : true
      if (
        (await this.$refs.grid.$refs.observer.validate()) &&
        (await this.$refs.gridProprio.$refs.observer.validate()) &&
        (await this.$refs.date.validateInput())
      ) {
        if (result || this.competencia === this.competenciaClone) {
          const colaborador = new Colaborador(this.tokenBearer, this.$appConfig.config.API, this.$idUnimed)

          this.colaboradores = this.$refs.grid.returnValues()
          this.colaboradoresProprios = this.$refs.gridProprio.returnValues()

          const data = { competencia: this.competencia, id: this.id, itens: this.itens, justificativa }

          await colaborador
            .putColaborador(data)
            .then((res) => {
              const mensagem = res.data.mensagem
              const gerouPendencia = res.data.gerouPendencia
              if (gerouPendencia) {
                this.$emit('gerouPendencia', { mensagem, gerouPendencia });
              } else {
                this.id = res.data.idCompetencia
                this.$emit('success', {
                  origin: 'colaboradores',
                  message: 'Quantidade de colaboradores atualizada com sucesso!'
                });
              }
            })
            .catch((err) => {
              this.getColaboradores()
              this.$emit('error', err)
            })
        } else {
          this.$emit('pendente', this.allowedMonths[0])
        }
      }
    },
    selecionarData(data) {
      if (data.length === 7 && data !== this.competencia) {
        this.editavel = true
        this.$emit('editavel', this.editavel)
        this.competencia = data
        this.$refs.grid.clean()
        this.$refs.gridProprio.clean()
      }
    }
  },
  watch: {
    loading() {
      this.$emit('input', this.loading)
    }
  },
  computed: {
    isMonthEmpty() {
      return this.allowedMonths.length === 0
    },
    totalColaborador() {
      let a = this.totalColaboradorA * 1 || 0
      let b = this.totalColaboradorB * 1 || 0
      let total = (a + b) * 1 || 0
      return total
    },
    totalPcd() {
      let a = this.totalPcdA * 1 || 0
      let b = this.totalPcdB * 1 || 0
      let total = (a + b) * 1 || 0
      return total
    },
    totalGeral() {
      let a = this.totalGeralA * 1 || 0
      let b = this.totalGeralB * 1 || 0
      let total = (a + b) * 1 || 0
      return total
    },
    itens() {
      return [
        {
          pcd: false,
          quantidadeItens: this.colaboradores.diretor,
          servicoProprio: false,
          tipoItem: 'DIRETOR'
        },
        {
          pcd: false,
          quantidadeItens: this.colaboradores.gestor,
          servicoProprio: false,
          tipoItem: 'GESTOR'
        },
        {
          pcd: false,
          quantidadeItens: this.colaboradores.colaborador,
          servicoProprio: false,
          tipoItem: 'COLABORADOR'
        },
        {
          pcd: false,
          quantidadeItens: this.colaboradores.estagiario,
          servicoProprio: false,
          tipoItem: 'ESTAGIARIO'
        },
        {
          pcd: false,
          quantidadeItens: this.colaboradores.aprendiz,
          servicoProprio: false,
          tipoItem: 'JOVEM_APRENDIZ'
        },
        {
          pcd: false,
          quantidadeItens: this.colaboradores.temporario,
          servicoProprio: false,
          tipoItem: 'TEMPORARIO'
        },
        {
          pcd: false,
          quantidadeItens: this.colaboradoresProprios.diretor,
          servicoProprio: true,
          tipoItem: 'DIRETOR'
        },
        {
          pcd: false,
          quantidadeItens: this.colaboradoresProprios.gestor,
          servicoProprio: true,
          tipoItem: 'GESTOR'
        },
        {
          pcd: false,
          quantidadeItens: this.colaboradoresProprios.colaborador,
          servicoProprio: true,
          tipoItem: 'COLABORADOR'
        },
        {
          pcd: false,
          quantidadeItens: this.colaboradoresProprios.estagiario,
          servicoProprio: true,
          tipoItem: 'ESTAGIARIO'
        },
        {
          pcd: false,
          quantidadeItens: this.colaboradoresProprios.aprendiz,
          servicoProprio: true,
          tipoItem: 'JOVEM_APRENDIZ'
        },
        {
          pcd: false,
          quantidadeItens: this.colaboradoresProprios.temporario,
          servicoProprio: true,
          tipoItem: 'TEMPORARIO'
        },
        {
          pcd: true,
          quantidadeItens: this.colaboradores.pcdDiretor,
          servicoProprio: false,
          tipoItem: 'DIRETOR'
        },
        {
          pcd: true,
          quantidadeItens: this.colaboradores.pcdGestor,
          servicoProprio: false,
          tipoItem: 'GESTOR'
        },
        {
          pcd: true,
          quantidadeItens: this.colaboradores.pcdColaborador,
          servicoProprio: false,
          tipoItem: 'COLABORADOR'
        },
        {
          pcd: true,
          quantidadeItens: this.colaboradores.pcdEstagiario,
          servicoProprio: false,
          tipoItem: 'ESTAGIARIO'
        },
        {
          pcd: true,
          quantidadeItens: this.colaboradores.pcdAprendiz,
          servicoProprio: false,
          tipoItem: 'JOVEM_APRENDIZ'
        },
        {
          pcd: true,
          quantidadeItens: this.colaboradores.pcdTemporario,
          servicoProprio: false,
          tipoItem: 'TEMPORARIO'
        },
        {
          pcd: true,
          quantidadeItens: this.colaboradoresProprios.pcdDiretor,
          servicoProprio: true,
          tipoItem: 'DIRETOR'
        },
        {
          pcd: true,
          quantidadeItens: this.colaboradoresProprios.pcdGestor,
          servicoProprio: true,
          tipoItem: 'GESTOR'
        },
        {
          pcd: true,
          quantidadeItens: this.colaboradoresProprios.pcdColaborador,
          servicoProprio: true,
          tipoItem: 'COLABORADOR'
        },
        {
          pcd: true,
          quantidadeItens: this.colaboradoresProprios.pcdEstagiario,
          servicoProprio: true,
          tipoItem: 'ESTAGIARIO'
        },
        {
          pcd: true,
          quantidadeItens: this.colaboradoresProprios.pcdAprendiz,
          servicoProprio: true,
          tipoItem: 'JOVEM_APRENDIZ'
        },
        {
          pcd: true,
          quantidadeItens: this.colaboradoresProprios.pcdTemporario,
          servicoProprio: true,
          tipoItem: 'TEMPORARIO'
        }
      ]
    }
  }
}
</script>
